<template>
  <div id="analyze-card">
    <div class="card-title">
      <div class="title">
        <div class="icon" :style="{ background: $util.acTitle(grade)}">
          <b-icon name="xiangmu" color="fff" :size="1"></b-icon>
        </div>
        <div class="inner" :style="{ color: $util.acTitle(grade)}">{{title}}</div>
      </div>
      <div class="right-total">
        <div class="rate" :style="{ color: $util.acNum(grade)}">{{rate}}%</div>
        <div class="proportion">({{right}}/{{total}})</div>
      </div>
    </div>
    <div class="card-progress">
      <el-progress
        :show-text="false"
        :stroke-width="10"
        :color="$util.acProcess(grade)"
        :percentage="percentage"
      ></el-progress>
    </div>
    <div class="card-text" v-html="info"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    right: {
      type: Number
    },
    total: {
      type: Number
    },
    info: {
      type: String
    },
    grade: {}
  },
  data() {
    return {
      rate: null,
      percentage: null
    };
  },
  created() {
    let num = (this.right / this.total) * 100;
    this.rate = parseInt(num) === num ? num : num.toFixed(2);
    this.percentage = parseInt(this.rate);
    console.log(this.percentage);
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
#analyze-card {
  width: 100%;
  padding: 3% 0;
  background: #fff;
  .card-title {
    width: 100%;
    padding: 0 3%;
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .title {
      display: flex;
      align-items: center;
      .icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        background: #da791f;
        border-radius: 50%;
        padding: 20px;
      }
      .inner {
        display: inline-flex;
        color: #da791f;
        margin-left: 2vw;
        font-size: 90px;
      }
    }
    .right-total {
      display: inline-flex;
      justify-content: center;
      align-items: flex-end;
      color: #f7bb2e;
      .rate {
        font-size: 100px;
      }
      .proportion {
        font-size: 65px;
        font-weight: 300;
        color: #bbb;
        margin-left: 40px;
        margin-bottom: 10px;
      }
    }
  }
  .card-progress {
    width: 100%;
    padding: 0 3%;
    margin-top: 60px;
    background: #fff;
  }
  .card-text {
    width: 100%;
    padding: 0 3%;
    margin-top: 60px;
    background: #fff;
    font-size: 75px !important;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/AnalyzeCard.vue